export const LocationContractStatus = {
    OPEN : "OPEN",
    ACCESSIBLE : "ACCESSIBLE",
    LOCKED : "LOCKED",
    CANCELLED : "CANCELLED",
}
